import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PaginationButton } from './PaginationButton-BQUQl9go.js';
import { E as angleInlineStart } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const PaginationPrevButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-prev-button'),
  icon: angleInlineStart
}, props));
PaginationPrevButton.displayName = 'PaginationPrevButton';

export { PaginationPrevButton as P };
//# sourceMappingURL=PaginationPrevButton-Dq8e_fFg.js.map
